import React, { useEffect, useRef } from 'react';
import { YouTubeHeader } from './YouTubeHeader';
import { YouTubeBody } from './YouTubeBody';

export const YouTubeStack = (props: { videoId: string; onClose: () => void; title: string }) => {
  const { videoId, onClose, title } = props;

  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.focus();
  }, []);

  return (
    <div className="attachments-view__container" tabIndex={-1} ref={containerRef}>
      <YouTubeHeader title={title} onClose={onClose} />
      <YouTubeBody videoId={videoId} onClose={onClose} />
    </div>
  );
};
